import React, { useEffect, useState } from "react";
import MaintenanceItemInputs from "../../Inputs/MaintenanceItemInputs/MaintenanceItemInputs";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createMaintenanceItem,
  deleteMaintenanceItem,
} from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";
import notify from "../../../hooks/useNotifaction";
import {
  createStandardMaintenanceItem,
  deleteStandardMaintenanceItem,
  getStandardMaintenanceItemsById,
  updateStandardMaintenanceItem,
} from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import Swal from "sweetalert2";
import { getAllMaintenanceSchedule } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";

export default function AddMaintenanceItem({ dataItem }) {
  const navigate = useNavigate();
  const { itemId } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { status, error, detailsStandardMaintenanceItemsById } = useSelector(
    (state) => state.standardMaintenanceItems,
  );
  const { allMaintenanceSchedule } = useSelector(
    (state) => state.maintenanceSchedule,
  );

  const [maintenanceItem, setMaintenanceItem] = useState({
    name: "",
    name_en: "",
    description: "",
    category: "",
    estimated_duration: "",
    status: "pending",
    notes: "",
    standard_item_id: null,
    schedule_id: "",
    parent_id: null,
  });
  useEffect(() => {
    console.log(maintenanceItem);
  }, [maintenanceItem]);
  useEffect(() => {
    if (itemId) {
      dispatch(getStandardMaintenanceItemsById(itemId));
    }
  }, [itemId]);
  useEffect(() => {
    dispatch(getAllMaintenanceSchedule());
  }, []);
  useEffect(() => {
    if (detailsStandardMaintenanceItemsById && itemId) {
      // console.log(detailsStandardMaintenanceItemsById);
      setMaintenanceItem(detailsStandardMaintenanceItemsById);
    }
  }, [detailsStandardMaintenanceItemsById, itemId]);

  // useEffect(() => {
  //   if (itemId) {
  //     setLoading(true);
  //     dispatch(getStandardMaintenanceItemsById(itemId))
  //       .then(() => setLoading(false))
  //       .catch(() => setLoading(false));
  //   }
  // }, [itemId, dispatch]);

  // useEffect(() => {
  //   if (detailsStandardMaintenanceItemsById && itemId) {
  //     setMaintenanceItem(detailsStandardMaintenanceItemsById);
  //   }
  // }, [detailsStandardMaintenanceItemsById, itemId]);

  // useEffect(() => {
  //   return () => {
  //     setMaintenanceItem({
  //       name: "",
  //       name_en: "",
  //       description: "",
  //       category: "",
  //       estimated_duration: "",
  //       status: "",
  //       notes: "",
  //       parent_id: null,
  //     });
  //   };
  // }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMaintenanceItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCategorySelect = (selectedOption) => {
    setMaintenanceItem((prev) => ({
      ...prev,
      category: selectedOption.value,
    }));
  };

  // const validateForm = () => {
  //   const requiredFields = {
  //     name: maintenanceItem.name,
  //     estimated_duration: maintenanceItem.estimated_duration,
  //     category: maintenanceItem.category,
  //   };

  //   const missingFields = Object.entries(requiredFields)
  //     .filter(([_, value]) => !value)
  //     .map(([key]) => key);

  //   if (missingFields.length > 0) {
  //     notify("يرجى ملء جميع الحقول المطلوبة", "warning");
  //     return false;
  //   }
  //   return true;
  // };

  const handleForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let action = itemId
        ? updateStandardMaintenanceItem({ id: itemId, data: maintenanceItem })
        : createStandardMaintenanceItem(maintenanceItem);

      await dispatch(action).unwrap();
      notify(`تم ${itemId ? "تحديث" : "إضافة"} العنصر بنجاح`, "success");
      navigate("/MaintenanceItems");
    } catch (err) {
      notify(err?.message || "حدث خطأ أثناء العملية", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!itemId) return;

    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من التراجع عن هذا الإجراء!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        await dispatch(deleteStandardMaintenanceItem(itemId)).unwrap();
        notify("تم حذف العنصر بنجاح", "success");
        navigate("/MaintenanceItems");
      } catch (err) {
        notify(err?.message || "حدث خطأ أثناء الحذف", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="main">
      <h2 className="text-white mb-4">
        {itemId ? "تعديل عنصر صيانة" : "إضافة عنصر صيانة"}
      </h2>
      <form onSubmit={handleForm}>
        <div className="card mb-3 pt-5 pb-2 px-3 companyProfile">
          <MaintenanceItemInputs
            isParentElement={false}
            allMaintenanceSchedule={allMaintenanceSchedule?.data}
            handleCategorySelect={handleCategorySelect}
            maintenanceItem={maintenanceItem}
            setMaintenanceItem={setMaintenanceItem}
            handleInputChange={handleInputChange}
          />
          <div className="d-flex justify-content-between flex-lg-row-reverse mt-5">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "جاري..." : itemId ? "تحديث" : "إضافة"}
            </button>
            {itemId && (
              <button
                type="button"
                onClick={handleDelete}
                className="btn btn-danger"
                disabled={loading}
              >
                {loading ? "جاري..." : "حذف"}
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}
